import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { RootState } from "../../app/store";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { PagerTargetEvent } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { useLocation } from "react-router-dom";
import { getAllStudentLeads } from "./services/integration.services";
import { clearStudentLeadList } from "./integrationSlice";
import { LoadingPanel } from "../../components/layout/Loading";
import AlertBox from "../../components/common/AlertBox";

const LeadCenterList: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const FormID = location?.state?.FormID;

  useEffect(() => {
    if (FormID) {
      dispatch(getAllStudentLeads(FormID));
    }

    return () => {
      dispatch(clearStudentLeadList());
    };
  }, []);

  return (
    <GridLayout
      cols={[{ width: "100%" }]}
      style={{ height: "100%", margin: "4px 10px" }}
    >
      <GridLayoutItem
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "15px 20px 15px 0",
          height: "80px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          FB/Insta Lead List
        </Typography.h4>
      </GridLayoutItem>
      <GridLayoutItem>
        <LeadGridComponent />
      </GridLayoutItem>
    </GridLayout>
  );
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const LeadGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const StudentLeadList = useAppSelector(
    (state: RootState) => state.integration.StudentLeadList
  );
  const loading = useAppSelector(
    (state: RootState) => state.integration.loading
  );

  const [uiLoading, setLoading] = useState<boolean>(false);
  const [isUpdated, setUpdated] = useState<boolean>(false);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();
  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All" ? StudentLeadList?.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  useEffect(() => {
    setUpdated(!isUpdated);
  }, [JSON.stringify(StudentLeadList), StudentLeadList.length]);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  if (uiLoading) return <LoadingPanel gridRef={gridRef} />;

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 1 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  return (
    <>
      {StudentLeadList && StudentLeadList?.length > 0 ? (
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 175px)" }}
          filterable={true}
          filter={filter}
          data={
            filter
              ? filterBy(StudentLeadList, filter)?.slice(
                  page.skip,
                  page.take + page.skip
                )
              : StudentLeadList?.slice(page.skip, page.take + page.skip)
          }
          onFilterChange={handleFilterChange}
          skip={page.skip}
          take={page.take}
          total={StudentLeadList?.length}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 15, "All"],
            pageSizeValue: pageSizeValue,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column field="FullName" title="Name" />
          <Column field="MobileNo" title="Mobile No." />
          <Column field="EmailID" title="Email ID" />
        </KendoGrid>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default LeadCenterList;
